import { LightbulbOn80Icon } from './LightbulbOn80Icon';

/**
 * author: Michael Irigoyen
 * id F3C06B83-1208-4E69-A039-692D4B870B5A
 * name lightbulb-on-80
 * version: 6.7.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/lightbulb-on-80.svg
 * tags
 * - Home Automation 
 */
export const LightbulbDimmer80Icon = LightbulbOn80Icon;
export default LightbulbDimmer80Icon